export default "__VITE_ASSET__4930589e__"